/** @format */

export const SCORECARD_PLUS_FALLBACK = {
  data: {
    scorecardList: {
      items: [
        {
          cartProductCard: {
            legalCopy:
              'Auto-renews annually. Benefits begin with next purchase. Purchase not eligible to earn Points or redeem Rewards. Cancel auto-renewal at any time in My Account. Subject to the ScoreCard+ Pilot Program Terms.',
            scLogoDarkAltText: 'Scorecard Plus Logo',
            scLogoDarkVariant: {
              _dmS7Url: 'https://s7d6.scene7.com/is/image/DSGAEMSites/SmallSCPlusLogo',
            },
          },
        },
      ],
    },
  },
};
